export const LABELS = {
  USER_INFO: "ユーザ情報",
  TYPE: "ユーザ種別",
  COMPANY_NAME: "事業者名",
  COMPANY_NAME_HD: "ホールディングス名",
  COMPANY_NAME_GW: "GW事業者名",
  EMAIL: "メールアドレス（ログインID）",
  FAMILY_NAME: "ユーザ氏名（姓）",
  GIVEN_NAME: "ユーザ氏名（名）",
  STATUS: "状態",
  MEMO: "備考",
  COMMENT: "内部コメント",
  REFERENCE_GROUP: "参照グループ",
  PRIVILEGE: "権限",
  SEARCH_MODAL_TITLE: "所属組織検索",
  PERMISSION: "権限",
  KANA: "・カナ",
  ACTION: "アクション",
  REISSUE: "仮パスワード再発行",
  REISSUE_MESSAGE: "このユーザの仮パスワードを再発行します。",
  PLACEHOLDER: {
    TYPE: "ユーザ種別を選択してください",
    PRIVILEGE: "権限を選択してください",
    REFERENCE_GROUP: "参照グループを選択してください",
  },
} as const;

/**　定数 */
export const SELECT_BY_COMPANY = "2";

export const getCompanyTypeLabel = (companyType: string) => {
  if (["02", "03"].includes(companyType)) {
    return LABELS.COMPANY_NAME;
  } else if (["04"].includes(companyType)) {
    return LABELS.COMPANY_NAME_HD;
  } else if (["05"].includes(companyType)) {
    return LABELS.COMPANY_NAME_GW;
  } else {
    return "";
  }
};
